module.exports = __webpack_public_path__ + "static/img/important.c6caaff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/assets/important.png
// module id = zuL7
// module chunks = 0